module.exports = __webpack_public_path__ + "static/media/logo-leclerc.c6d56847.svg";